export default __webpack_public_path__ + "static/media/badge.7ad87386.svg";